<template>
<div>
  <v-tooltip v-if="isShort" bottom>
    <template v-slot:activator="{on}">
      <v-chip v-on="on">Too big to display, mouse over this.</v-chip>
    </template>
    <tr v-if="is_update">
      <td>{{fromValue}}</td>
    </tr>
    <tr v-if="is_update">
      <td class="text-center"><v-icon>mdi-arrow-down</v-icon></td>
    </tr>
    <tr>
      <td>{{value}}</td>
    </tr>
  </v-tooltip>
  <template v-else>
    <span>
       {{ fromValue }} =>
        <span style="white-space:nowrap">
          {{value}}
        </span>
    </span>
  </template>
</div>
</template>

<script>
export default {
    name: "LogDiff",
    components: {},
    props: {
      diff: {
        required: true,
      },
      is_update: {
        default: false,
        type: Boolean
      }
    },
    data: () => ({}),
    computed: {
      fromValue(){
        return this.diff.from_display_text ? this.diff.from_display_text : this.diff.from_value;
      },
      value(){
        return this.diff.display_text ? this.diff.display_text : this.diff.value;
      },
      isShort(){
        let newVaue = this.diff.display_text ? this.diff.display_text : this.diff.value;
        let original = this.diff.from_display_text ? this.diff.from_display_text : this.diff.from_value;
        if((typeof newVaue === "string" && newVaue.length > 80) || (typeof original === "string" && original.length > 80) || ([newVaue,original].every(item => typeof item === "string") && newVaue.length + original.length > 80)){
            return true;
        }
      }
    },
    methods: {}
}
</script>

<style scoped>

</style>
